module.exports = __webpack_public_path__ + "img/agweb-monitor.c30189fb.png";